import { z } from "zod/v4";

export const DeleteProcessesRequestPathParamSchema = z.object({
  processId: z.string(),
});

export type DeleteProcessesRequestPathParamType = z.infer<
  typeof DeleteProcessesRequestPathParamSchema
>;
